import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { PlanoAcao } from '../../models/plano-acao.model';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';
import { PontoCriticoAcaoSituacaoService } from '../../services/ponto-critico-acao-situacao.service';
import { PontoCriticoAcaoService } from '../../services/ponto-critico-acao.service';

@Component({
  selector: 'app-pontos-criticos-acao-view',
  templateUrl: './pontos-criticos-acao-view.component.html',
  styleUrls: ['./pontos-criticos-acao-view.component.scss']
})
export class PontosCriticosAcaoViewComponent extends BaseListComponent<PlanoAcao> implements OnInit, OnDestroy {

  idProjeto: number;
  infoProjeto: ProjetoCadastro;
  idEntrega: number;
  idIndicador: number;
  idPgIndicador: number;
  idPontoCriticoProjeto: number;
  idPontoCriticoEntrega: number;
  idPontoCriticoIndicador: number;
  idPontoCriticoPgIndicador: number;
  acao: PlanoAcao;

  constructor(
    private pcAcaoService: PontoCriticoAcaoService,
    private acaoSituacao: PontoCriticoAcaoSituacaoService,
    private activatedRoute: ActivatedRoute,
		private router: Router,
    private pesquisaGeralService: PesquisaGeralService,
  ) {
    super()
  }

  ngOnInit(): void {
    this.pesquisaGeralService.info.subscribe(info => {
      this.infoProjeto = info;
      this.idProjeto = this.infoProjeto.id;
      this.acao = this.activatedRoute.snapshot.data['entity'];
      if (this.activatedRoute.snapshot.params.idPontoCritico) {
        this.idPontoCriticoProjeto = this.activatedRoute.snapshot.params.idPontoCritico;
      } else if (this.activatedRoute.snapshot.params.idPontoCriticoEntrega) {
        this.idPontoCriticoEntrega = this.activatedRoute.snapshot.params.idPontoCriticoEntrega;
        if (this.activatedRoute.snapshot.params.idEntrega) { // acessado a partir da aba de entregas
          this.idEntrega = this.activatedRoute.snapshot.params.idEntrega;
        }
      } else if (this.activatedRoute.snapshot.params.idPontoCriticoIndicador) {
        this.idPontoCriticoIndicador = this.activatedRoute.snapshot.params.idPontoCriticoIndicador;
        if (this.activatedRoute.snapshot.params.idIndicador) { // acessado a partir da aba de indicador
          this.idIndicador = this.activatedRoute.snapshot.params.idIndicador;
        }
      } else if (this.activatedRoute.snapshot.params.idPontoCriticoPgIndicador) {
        this.idPontoCriticoPgIndicador = this.activatedRoute.snapshot.params.idPontoCriticoPgIndicador;
        this.idPgIndicador = this.activatedRoute.snapshot.params.idPgIndicador;
      }
      
      this.validaIds();
      this.loaded();
    });
  }

  validaIds() {
    // Valida se a ação do idAcao na url da rota pertence ao idProjeto da rota
    if (this.acao.pf_id != this.idProjeto && this.acao.pg_id != this.idProjeto) { // projeto ou projeto agregador/programa
      this.voltar();
    }
    // valida se o id do ponto critico na url da rota pertence ao id do ponto critico da ação
    if (this.idPontoCriticoProjeto) {
      this.validaId(this.acao.critical_id, this.idPontoCriticoProjeto);
    }
    if (this.idPontoCriticoEntrega) {
      this.validaId(this.acao.prt_issue_critical_id, this.idPontoCriticoEntrega);
    }
    if (this.idPontoCriticoIndicador) {
      this.validaId(this.acao.ind_critical_id, this.idPontoCriticoIndicador);
    }
    if (this.idPontoCriticoPgIndicador) {
      this.validaId(this.acao.ind_critical_id, this.idPontoCriticoPgIndicador);
    }
  }

  validaId(id1: any, id2: any) {
    if (id1 != id2) {
      this.voltar();
    }
  }

  initList() {
    if (this.idPontoCriticoProjeto) {
      this.addSub(
        this.pcAcaoService.getByIdSimple(this.acao?.id).subscribe({
          next: (res) => {
            this.acao = res;
            this.loaded();
          },
        })
      )
    } else if (this.idPontoCriticoIndicador) {
      this.addSub(
        this.pcAcaoService.getByIdIndicadorSimple(this.acao?.id).subscribe({
          next: (res) => {
            this.acao = res;
            this.loaded();
          },
        })
      )
    } else if (this.idPontoCriticoPgIndicador) {
      this.addSub(
        this.pcAcaoService.getByIdAgregadorIndicadorSimple(this.acao?.id).subscribe({
          next: (res) => {
            this.acao = res;
            this.loaded();
          },
        })
      )
    } else if (this.idPontoCriticoEntrega) {
      this.addSub(
        this.pcAcaoService.getByIdEntregaSimple(this.acao?.id).subscribe({
          next: (res) => {
            this.acao = res;
            this.loaded();
          },
        })
      )
    }
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  editar() {
    if (this.idPontoCriticoProjeto) {
      return ['/projetos', 'projeto', this.idProjeto, 'pontos-criticos', this.idPontoCriticoProjeto, 'plano-acao', this.acao?.id, 'editar'];
    } else if (this.idPontoCriticoIndicador) {
      if (this.idIndicador) { // navegação a partir da aba de indicadores
        return ['/projetos', 'projeto', this.idProjeto, 'indicadores', this.idIndicador, 'ponto-critico', this.idPontoCriticoIndicador, 'plano-acao', this.acao?.id, 'editar'];
      } else { // navegação a partir da aba de pontos criticos
        return ['/projetos', 'projeto', this.idProjeto, 'pontos-criticos', 'indicador', this.idPontoCriticoIndicador, 'plano-acao', this.acao?.id, 'editar'];
      }
    } else if (this.idPontoCriticoEntrega) {
      if (this.idEntrega) { // navegação a partir da aba de entregas
        return ['/projetos', 'projeto', this.idProjeto, 'entregas', this.idEntrega, 'ponto-critico', this.idPontoCriticoEntrega, 'plano-acao', this.acao?.id, 'editar'];
      } else { // navegação a partir da aba de pontos criticos
        return ['/projetos', 'projeto', this.idProjeto, 'pontos-criticos', 'entrega', this.idPontoCriticoEntrega, 'plano-acao', this.acao?.id, 'editar'];
      }
    } else if (this.idPontoCriticoPgIndicador) {
      return ['/projetos', 'agregador', 'indicadores', this.idPgIndicador, 'ponto-critico', this.idPontoCriticoPgIndicador, 'plano-acao', this.acao?.id, 'editar'];
    }
  }

  confirmExcluir(idSituacao: any = false) {
    this.alertConfirmation().subscribe((confirmed) => {
      if (confirmed && idSituacao) {
        this.excluirSituacao(idSituacao);
      }
    });
  }
  
  voltar() {
    this.router.navigate(['../../../'], { relativeTo: this.activatedRoute });
  }

  editarSituacao(id: number) {
    if (this.idPontoCriticoProjeto) {
      return ['/projetos', 'projeto', this.idProjeto, 'pontos-criticos', this.idPontoCriticoProjeto, 'plano-acao', this.acao?.id, 'situacao', id];
    } else if (this.idPontoCriticoIndicador) {
      if (this.idIndicador) { // navegação a partir da aba de indicadores
        return ['/projetos', 'projeto', this.idProjeto, 'indicadores', this.idIndicador, 'ponto-critico', this.idPontoCriticoIndicador, 'plano-acao',  this.acao?.id, 'situacao', id];
      } else { // navegação a partir da aba de pontos criticos
        return ['/projetos', 'projeto', this.idProjeto, 'pontos-criticos', 'indicador', this.idPontoCriticoIndicador, 'plano-acao', this.acao?.id, 'situacao', id];
      }
    } else if (this.idPontoCriticoEntrega) {
      if (this.idEntrega) { // navegação a partir da aba de entregas
        return ['/projetos', 'projeto', this.idProjeto, 'entregas', this.idEntrega, 'ponto-critico', this.idPontoCriticoEntrega, 'plano-acao',  this.acao?.id, 'situacao', id];
      } else { // navegação a partir da aba de pontos criticos
        return ['/projetos', 'projeto', this.idProjeto, 'pontos-criticos', 'entrega', this.idPontoCriticoEntrega, 'plano-acao', this.acao?.id, 'situacao', id];
      }
    } else if (this.idPontoCriticoPgIndicador) {
      return ['/projetos', 'agregador', 'indicadores', this.idPgIndicador, 'ponto-critico', this.idPontoCriticoPgIndicador, 'plano-acao', this.acao?.id, 'situacao', id];
    }
  }

  novaSituacao() {
    if (this.idPontoCriticoProjeto) {
      return ['/projetos', 'projeto', this.idProjeto, 'pontos-criticos', this.idPontoCriticoProjeto, 'plano-acao', this.acao?.id, 'situacao', 'adicionar'];
    } else if (this.idPontoCriticoIndicador) {
      if (this.idIndicador) { // navegação a partir da aba de indicadores
        return ['/projetos', 'projeto', this.idProjeto, 'indicadores', this.idIndicador, 'ponto-critico', this.idPontoCriticoIndicador, 'plano-acao',  this.acao?.id, 'situacao', 'adicionar'];
      } else { // navegação a partir da aba de pontos criticos
        return ['/projetos', 'projeto', this.idProjeto, 'pontos-criticos', 'indicador', this.idPontoCriticoIndicador, 'plano-acao', this.acao?.id, 'situacao', 'adicionar'];
      }
    } else if (this.idPontoCriticoEntrega) {
      if (this.idEntrega) { // navegação a partir da aba de entregas
        return ['/projetos', 'projeto', this.idProjeto, 'entregas', this.idEntrega, 'ponto-critico', this.idPontoCriticoEntrega, 'plano-acao',  this.acao?.id, 'situacao', 'adicionar'];
      } else { // navegação a partir da aba de pontos criticos
        return ['/projetos', 'projeto', this.idProjeto, 'pontos-criticos', 'entrega', this.idPontoCriticoEntrega, 'plano-acao', this.acao?.id, 'situacao', 'adicionar'];
      }
    } else if (this.idPontoCriticoPgIndicador) {
      return ['/projetos', 'agregador', 'indicadores', this.idPgIndicador, 'ponto-critico', this.idPontoCriticoPgIndicador, 'plano-acao', this.acao?.id, 'situacao', 'adicionar'];
    }
  }

  novaDemandaLink() {
    return ['/projetos', 'projeto', this.idProjeto, 'demandas', 'adicionar'];
  }

  novaDemandaParams(id: number) {
    if (this.idPontoCriticoProjeto) {
      return { pf_action_analysis_id: id };
    } else if (this.idPontoCriticoIndicador) {
      return { pf_ind_action_analysis_id: id };
    } else if (this.idPontoCriticoEntrega) {
      return { pf_prt_issue_action_analysis_id: id };
    }
  }

  excluirSituacao(id: number) {
    this.loading();
    if (this.idPontoCriticoProjeto) {
      this.acaoSituacao.delete(id).subscribe({
        next: (res) => {
          this.loaded();
          this.confirmation().subscribe(() => {
            this.initList();
          });
        },
        error: (error) => {
          this.msgError(error.error?.message);
          this.loaded();
        }
      });
    } else if (this.idPontoCriticoIndicador) {
      this.acaoSituacao.indicadorDelete(id).subscribe({
        next: (res) => {
          this.loaded();
          this.confirmation().subscribe(() => {
            this.initList();
          });
        },
        error: (error) => {
          this.msgError(error.error?.message);
          this.loaded();
        }
      });
    } else if (this.idPontoCriticoEntrega) {
      this.acaoSituacao.entregaDelete(id).subscribe({
        next: (res) => {
          this.loaded();
          this.confirmation().subscribe(() => {
            this.initList();
          });
        },
        error: (error) => {
          this.msgError(error.error?.message);
          this.loaded();
        }
      });
    } else if (this.idPontoCriticoPgIndicador) {
      this.acaoSituacao.agregadorIndicadorDelete(id).subscribe({
        next: (res) => {
          this.loaded();
          this.confirmation().subscribe(() => {
            this.initList();
          });
        },
        error: (error) => {
          this.msgError(error.error?.message);
          this.loaded();
        }
      });
    }
  }
}